// Get root domain and optionally add subdomain
export function getRootDomain(subdomain = "") {
    const url = window.location.hostname;

    // Handle localhost (dev environment)
    if (url === "localhost") {
        return `http://${subdomain}.localhost:3000`;
    }

    const parts = url.split(".");

    // List of common second-level domains (SLDs) that use ccTLDs
    const sldList = ["com.au", "uk", "co.nz", "us", "com.co"];

    // Check for specific cases where the domain is two-part (e.g., co.uk)
    const lastTwoParts = parts.slice(-2).join(".");
    let rootDomain;

    if (sldList.includes(lastTwoParts)) {
        rootDomain = parts.slice(-3).join("."); // Handle domains like example.co.uk
    } else {
        rootDomain = parts.length > 2 ? parts.slice(-2).join(".") : url;
    }

    // Add the optional subdomain if provided
    if (subdomain) {
        return `https://${subdomain}.${rootDomain}`;
    }

    return `https://${rootDomain}`;
}

export function insertSubdomain(url: string, subdomain: string): string {
    try {
        // Create a new URL object
        const parsedUrl = new URL(url);

        // Split the hostname into parts (subdomain + domain)
        const hostParts = parsedUrl.hostname.split(".");

        // Insert the subdomain before the domain part
        if (hostParts.length > 1) {
            hostParts.unshift(subdomain);
        } else {
            // If no valid domain is detected, just prepend the subdomain
            hostParts[0] = `${subdomain}.${hostParts[0]}`;
        }

        // Reassemble the new hostname
        parsedUrl.hostname = hostParts.join(".");

        // Return the modified URL as a string
        return parsedUrl.toString();
    } catch (error) {
        // console.error("Invalid URL provided:", error);
        return url;
    }
}

export const AU_ROOT_DOMAIN = "foreverinourhearts.com.au";
export const GLOBAL_ROOT_DOMAIN = "foreverinourhearts.co";

// "global" on the International hub (foreverinourhearts.co), otherwise "au" (including localhost)
export function getRegion(): "au" | "global" {
    const hostname = window.location.hostname.toLowerCase();
    return (hostname === GLOBAL_ROOT_DOMAIN || hostname.endsWith(`.${GLOBAL_ROOT_DOMAIN}`)) ? "global" : "au";
}

// Region badge for root admin lists: "AU" or "INTL" (International). Records without a region are AU.
export function regionBadge(region?: "au" | "global" | "both"): { label: string, tone: "default" | "accent" } {
    if (region === "both") return { label: "AU + INTL", tone: "accent" };
    return region === "global" ? { label: "INTL", tone: "accent" } : { label: "AU", tone: "default" };
}

export const REGION_OPTIONS = [
    { label: "Australia", value: "au" },
    { label: "International", value: "global" },
];

export const CHARITY_REGION_OPTIONS = [
    ...REGION_OPTIONS,
    { label: "Both Australia and International", value: "both" },
];
